import { Updater } from "widgets-for-react"
import { CompanyState, initialCompanyState } from "../../forms/company/companyState"
import { initialPersonalInfoState, PersonalInfoState } from "../../forms/personalInfo/personalInfoState"
import { UserData } from "../subscriptionState"
import { initialSubscriptionPriceSelectorState, SubscriptionPriceSelectorState } from "forms/subscriptionPriceSelector/subscriptionPriceSelectorState"

export type StripeUpgradeSubscriptionState = {
  step: 1 | 2
  personalInfoState:PersonalInfoState
  subscriptionPriceSelectorState:SubscriptionPriceSelectorState,
  isCompany?: boolean,
  companyState: CompanyState,
  termsAndConditions?: boolean,
  isValid():boolean,
}

export const initialStripeUpgradeSubscriptionState = (userData?:UserData) : StripeUpgradeSubscriptionState => ({
  step:1,
  personalInfoState:initialPersonalInfoState(userData),
  subscriptionPriceSelectorState:initialSubscriptionPriceSelectorState(),
  companyState: initialCompanyState(userData),
  isCompany: undefined,
  termsAndConditions: undefined,
  isValid:function(this:StripeUpgradeSubscriptionState) { 
    if (this.step == 1)
      return this.subscriptionPriceSelectorState.isValid()
    
    return this.personalInfoState.isValid(true) && this.termsAndConditions === true && (this.isCompany === true ? this.companyState?.isValid() : true)
  }
})

export const stripeUpgradeSubscriptionInputUpdaters = {
  nextStep:() : Updater<StripeUpgradeSubscriptionState> =>
    s => ({...s, step:s.step == 1 ? 2 : s.step}),
  prevStep:() : Updater<StripeUpgradeSubscriptionState> =>
    s => ({...s, step: s.step == 2 ? 1 : s.step}),
  isCompany: (u: StripeUpgradeSubscriptionState["isCompany"]) =>
    (s : StripeUpgradeSubscriptionState) : StripeUpgradeSubscriptionState => ({ ...s, isCompany: u }),
  termsAndConditions: (u: StripeUpgradeSubscriptionState["termsAndConditions"]) =>
    (s : StripeUpgradeSubscriptionState) : StripeUpgradeSubscriptionState => ({ ...s, termsAndConditions: u }),
  companyState:(u:Updater<StripeUpgradeSubscriptionState["companyState"]>) : Updater<StripeUpgradeSubscriptionState> =>
    s => ({...s, companyState:u(s.companyState)}),
  personalInfoState:(u:Updater<StripeUpgradeSubscriptionState["personalInfoState"]>) : Updater<StripeUpgradeSubscriptionState> =>
    s => ({...s, personalInfoState:u(s.personalInfoState)}),
  subscriptionSelectorState:(u:Updater<StripeUpgradeSubscriptionState["subscriptionPriceSelectorState"]>) : Updater<StripeUpgradeSubscriptionState> =>
    s => ({...s, subscriptionPriceSelectorState:u(s.subscriptionPriceSelectorState)}),
 }